import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useCart } from './Cart';
import Header from './Header';
import Footer from './Footer';
import ConsultationForm from './ConsultationForm';
import GiftSetModal from './GiftSetModal';
import ProductModal from './ProductModal';
import { FaGem, FaTrophy, FaWater, FaBullseye, FaGift } from 'react-icons/fa';

function Catalog() {
  const { addToCart } = useCart();
  const [products, setProducts] = useState({ monoSets: [], originalSeries: [], farEastSeries: [], giftSets: [] });
  const [loading, setLoading] = useState(true);
  const [showConsultationForm, setShowConsultationForm] = useState(false);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [selectedGiftSet, setSelectedGiftSet] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'products'));
      const productsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      const categorized = {
        monoSets: productsData.filter(p => p.category === 'monoSets'),
        originalSeries: productsData.filter(p => p.category === 'originalSeries'),
        farEastSeries: productsData.filter(p => p.category === 'farEastSeries'),
        giftSets: productsData.filter(p => p.category === 'giftSets')
      };
      
      setProducts(categorized);
      setLoading(false);
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
      alert('Ошибка загрузки каталога. Попробуйте позже.');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="App">
        <Header />
        <div style={{textAlign: 'center', padding: '10rem 2rem 5rem', fontSize: '1.5rem'}}>Загрузка каталога...</div>
      </div>
    );
  }
  
  return (
    <div className="App">
      <Header />

      <section className="section" style={{paddingTop: '12rem'}}>
        <h2>Полный каталог наборов</h2>
        
        <h3 className="category-title"><FaGem /> Моно наборы</h3>
        <div className="category-description">
          <p>Чистые ингредиенты для классических настоек</p>
          <span className="category-badge">от 90₽</span>
        </div>
        <div className="catalog-grid">
          {products.monoSets.map(product => (
            <div key={product.id} className="product-card" onClick={() => { setSelectedProduct(product); setShowProductModal(true); }}>
              {product.images && product.images.length > 0 ? (
                <img src={product.images[0]} alt={product.name} className="product-image" />
              ) : (
                <div className="product-placeholder">П</div>
              )}
              <div className="product-content">
                <h3>{product.name}</h3>
                <div className="product-info">
                  {product.price && <span className="price">{product.price}</span>}
                </div>
                <button 
                  className="add-to-cart-btn"
                  onClick={(e) => { e.stopPropagation(); addToCart(product); }}
                  disabled={!product.stock || product.stock === 0}
                >
                  {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'Добавить в корзину'}
                </button>
              </div>
            </div>
          ))}
        </div>

        <h3 className="category-title"><FaTrophy /> Оригинальная серия</h3>
        <div className="category-description">
          <p>Авторские композиции от мастеров</p>
          <span className="category-badge">от 160₽</span>
        </div>
        <div className="catalog-grid">
          {products.originalSeries.map(product => (
            <div key={product.id} className="product-card" onClick={() => { setSelectedProduct(product); setShowProductModal(true); }}>
              {product.images && product.images.length > 0 ? (
                <img src={product.images[0]} alt={product.name} className="product-image" />
              ) : (
                <div className="product-placeholder">О</div>
              )}
              <div className="product-content">
                <h3>{product.name}</h3>
                <div className="product-info">
                  <span className="price">{product.price}</span>
                  {product.composition && <span className="composition">{product.composition}</span>}
                  {product.description && <div className="description">{product.description}</div>}
                </div>
                <button 
                  className="add-to-cart-btn"
                  onClick={(e) => { e.stopPropagation(); addToCart(product); }}
                  disabled={!product.stock || product.stock === 0}
                >
                  {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'Добавить в корзину'}
                </button>
              </div>
            </div>
          ))}
        </div>

        <h3 className="category-title"><FaWater /> Дальневосточная серия</h3>
        <div className="category-description">
          <p>Эксклюзивные композиции Дальнего Востока</p>
          <span className="category-badge">от 175₽</span>
        </div>
        <div className="catalog-grid">
          {products.farEastSeries.map(product => (
            <div key={product.id} className="product-card" onClick={() => { setSelectedProduct(product); setShowProductModal(true); }}>
              {product.images && product.images.length > 0 ? (
                <img src={product.images[0]} alt={product.name} className="product-image" />
              ) : (
                <div className="product-placeholder">Д</div>
              )}
              <div className="product-content">
                <h3>{product.name}</h3>
                <div className="product-info">
                  <span className="price">{product.price}</span>
                  {product.composition && <span className="composition">{product.composition}</span>}
                  {product.description && <div className="description">{product.description}</div>}
                </div>
                <button 
                  className="add-to-cart-btn"
                  onClick={(e) => { e.stopPropagation(); addToCart(product); }}
                  disabled={!product.stock || product.stock === 0}
                >
                  {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'Добавить в корзину'}
                </button>
              </div>
            </div>
          ))}
        </div>

        <h3 className="category-title"><FaGift /> Подарочная серия</h3>
        <div className="category-description">
          <p>Премиум наборы в подарочной упаковке</p>
          <span className="category-badge">от 1990₽</span>
        </div>
        <div className="catalog-grid">
          {products.giftSets.map(product => (
            <div key={product.id} className="product-card gift-card">
              {product.images && product.images.length > 0 ? (
                <img src={product.images[0]} alt={product.name} className="product-image" />
              ) : (
                <div className="product-placeholder">🎁</div>
              )}
              <div className="product-content">
                <h3>{product.name}</h3>
                <div className="product-info">
                  <span className="price">{product.price}</span>
                  {product.description && <div className="description">{product.description}</div>}
                </div>
                <button 
                  className="add-to-cart-btn gift-btn"
                  onClick={() => {
                    setSelectedGiftSet(product);
                    setShowGiftModal(true);
                  }}
                  disabled={!product.stock || product.stock === 0}
                >
                  {!product.stock || product.stock === 0 ? 'Нет в наличии' : 'Выбрать вкусы и добавить'}
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="catalog-footer">
          <div className="catalog-cta">
            <h3><FaBullseye /> Не можете выбрать?</h3>
            <p>Закажите консультацию - поможем подобрать идеальный набор!</p>
            <button onClick={() => setShowConsultationForm(true)} className="cta-button">Получить консультацию</button>
          </div>
        </div>
      </section>
      
      <Footer />
      
      <ConsultationForm 
        isOpen={showConsultationForm} 
        onClose={() => setShowConsultationForm(false)} 
      />
      
      <GiftSetModal
        isOpen={showGiftModal}
        onClose={() => setShowGiftModal(false)}
        onAddToCart={addToCart}
        giftSet={selectedGiftSet}
      />
      
      <ProductModal
        product={selectedProduct}
        isOpen={showProductModal}
        onClose={() => setShowProductModal(false)}
        onAddToCart={addToCart}
      />
    </div>
  );
}

export default Catalog;
